export default "__VITE_ASSET__BMM0ouBc__"